const BRIEFING_CLIENT_TIMEOUT_MS = 12_000;

/**
 * A server-function transport can outlive the database timeout when the
 * backend or network is unhealthy. Always settle the UI request so a Brief
 * page can show its cached/empty state instead of displaying a loader forever.
 */
export async function settleBriefingRequest<T>(
  request: Promise<T>,
  fallback: T,
  timeoutMs = BRIEFING_CLIENT_TIMEOUT_MS,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      request.catch(() => fallback),
      new Promise<T>((resolve) => {
        timer = setTimeout(() => resolve(fallback), timeoutMs);
      }),
    ]);
  } finally {
    if (timer) clearTimeout(timer);
  }
}